import { t } from "@lingui/macro";
import { RefObject } from "react";
import { ScrollView } from "react-native";

import { DiningBookingWizard } from "@/features/BookingWizard/DiningBookingWizard/types";
import { VStack, Text } from "@whoosh/design-system/src/components/primitive";

import { DiningWizardDietaryTagsControl } from "./components/DiningWizardDietaryTagsControl/DiningWizardDietaryTagsControl";
import { DiningWizardNotesControl } from "./components/DiningWizardNotesControl/DiningWizardNotesControl";
import { DiningWizardOccasionTagsControl } from "./components/DiningWizardOccasionTagsControl/DiningWizardOccasionTagsControl";
import { DiningWizardPartySizeControl } from "./components/DiningWizardPartySizeControl/DiningWizardPartySizeControl";

type Props = {
  diningDietaryTags: DiningBookingWizard.DiningBookingWizardData["dietaryTags"];
  diningOccasionTags: DiningBookingWizard.DiningBookingWizardData["occasionTags"];
  scrollViewRef: RefObject<ScrollView | null>;
};

export const DiningWizardDetailStep = ({
  diningDietaryTags,
  diningOccasionTags,
  scrollViewRef,
}: Props) => {
  return (
    <VStack paddingTop={2} gap={2}>
      <DiningWizardPartySizeControl />
      <VStack gap={5} backgroundColor="surface-primary" padding={5}>
        <Text variant="mainHeading">{t`Special Requests`}</Text>
        <DiningWizardDietaryTagsControl options={diningDietaryTags} />
        <DiningWizardOccasionTagsControl options={diningOccasionTags} />
        <DiningWizardNotesControl scrollViewRef={scrollViewRef} />
      </VStack>
    </VStack>
  );
};
